<template>
  <el-date-picker
    v-model="_value"
    class="my-select"
    :clearable="false"
    v-bind="$attrs"
    :disabled="disabled"
    :type="type"
    :style="_style"
    :value-format="valueFormat"
    :placeholder="$t('components.global.selectDate')"
    @change="change"
  />
</template>

<script>

export default {
  name: 'DatePickerItem',
  props: {
    value: {
      type: String
    },
    width: {
      type: String,
      default: '280px'
    },
    height: {
      type: String,
      default: '40px'
    },
    styleSheet: {
      type: Object,
      default: function() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "date"
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd"
    },
  },
  data() {
    return {}
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    _style() {
      return Object.assign(
        {},
        {
          width: this.width,
          height: this.height,
          'line-height': this.height
        },
        this.styleSheet
      )
    }
  },
  methods: {
    change(val) {
      this._value = val
    }
  }
}
</script>
<style lang='scss' scoped>
.my-select {
	::v-deep.el-date-editor {
		width: 280px;
		height: 32px;
		line-height: 32px;
		border-radius: 20px;
		.el-input__inner {
			justify-content: center;
			border-radius: 20px;
		}
	}
}
</style>
